export default __webpack_public_path__ + "static/media/contact-punch-dark.c5f0abd8.svg";